const DATABASE_NAME = "prospection-paris-sud"
const STORE_NAME = "key-value"
const DATABASE_VERSION = 1

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE_NAME, DATABASE_VERSION)
    request.onerror = () => reject(request.error)
    request.onupgradeneeded = () => request.result.createObjectStore(STORE_NAME)
    request.onsuccess = () => resolve(request.result)
  })
}

export function createStorage(namespace) {
  const keyFor = (key) => `${namespace}:${key}`

  async function transact(mode, operation) {
    const database = await openDatabase()

    return new Promise((resolve, reject) => {
      const transaction = database.transaction(STORE_NAME, mode)
      const request = operation(transaction.objectStore(STORE_NAME))
      request.onerror = () => reject(request.error)
      request.onsuccess = () => resolve(request.result)
      transaction.oncomplete = () => database.close()
      transaction.onerror = () => reject(transaction.error)
    })
  }

  return {
    get: (key) => transact("readonly", (store) => store.get(keyFor(key))),
    set: (key, value) => transact("readwrite", (store) => store.put(value, keyFor(key))),
    delete: (key) => transact("readwrite", (store) => store.delete(keyFor(key)))
  }
}
